"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validation = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Validation() {
    return react_1.default.createElement("div", { className: 'rounded bg-white mb-sm' },
        react_1.default.createElement(storybook_1.Billings.TextBlock, null,
            react_1.default.createElement("div", { className: 'flex justify-between py-sm' },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Bankrekening Valideren"),
                    react_1.default.createElement(storybook_1.Texts.Small, null, "Valideer je bankrekening met een eenmalige betaling van \u20AC0,05 om uitbetaald te worden.")),
                react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary' }, "Valideren"))));
}
exports.Validation = Validation;
